<div class="dialog-container">
  <div class="dialog-header">
    <h2 mat-dialog-title class="text-gradient">Inscrição no Evento</h2>
    <p>{{ data.event.title }} - {{ data.event.price | currency:'BRL' }}
      <span class="fee-info" *ngIf="showServiceFee"> + taxa de 10%</span>
    </p>
    <button mat-icon-button class="close-btn" (click)="onCancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <form [formGroup]="subscriptionForm" (ngSubmit)="onSubmit()" class="subscription-form">

      <h3 class="section-title">Dados do Participante</h3>

      <div class="form-row">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Nome Completo</mat-label>
          <input matInput formControlName="fullName" placeholder="Seu nome como no documento">
          <mat-icon matSuffix>person</mat-icon>
        </mat-form-field>
      </div>

      <div class="form-row grid-2">
        <mat-form-field appearance="outline">
          <mat-label>CPF</mat-label>
          <input matInput formControlName="cpf" placeholder="000.000.000-00" mask="000.000.000-00">
          <mat-icon matSuffix>fingerprint</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Data de Nascimento</mat-label>
          <input matInput [matDatepicker]="picker" formControlName="birthDate">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Telefone</mat-label>
          <input matInput formControlName="phone" placeholder="(00) 00000-0000" mask="(00) 00000-0000">
          <mat-icon matSuffix>phone</mat-icon>
        </mat-form-field>
      </div>

      <ng-container *ngIf="eventHasKit">
        <mat-divider class="section-divider"></mat-divider>
        <h3 class="section-title">Tamanho do Kit</h3>

        <div class="form-row">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Tamanho da camiseta</mat-label>
            <mat-select formControlName="kitSize">
              <mat-option [value]="noKit">Sem kit</mat-option>
              <mat-option *ngFor="let kit of availableKitSizes" [value]="kit.size">
                {{ kit.size }} ({{ kit.availableQuantity }} disponível(is))
              </mat-option>
            </mat-select>
            <mat-icon matSuffix>checkroom</mat-icon>
            <mat-hint *ngIf="availableKitSizes.length === 0">Todos os tamanhos estão esgotados</mat-hint>
          </mat-form-field>
        </div>
      </ng-container>

      <mat-divider class="section-divider"></mat-divider>
      <h3 class="section-title">Contato de Emergência</h3>

      <div class="form-row">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Nome do Contato</mat-label>
          <input matInput formControlName="emergencyContactName" placeholder="Quem avisar em caso de urgência?">
          <mat-icon matSuffix>contact_emergency</mat-icon>
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Telefone de Emergência</mat-label>
          <input matInput formControlName="emergencyContactPhone" placeholder="(00) 00000-0000" mask="(00) 00000-0000">
          <mat-icon matSuffix>phone_enabled</mat-icon>
        </mat-form-field>
      </div>

      <ng-container *ngIf="isPaidEvent">
        <mat-divider class="section-divider"></mat-divider>
        <h3 class="section-title">Cancelamento e reembolso</h3>
        <div class="policy-box">
          <p class="policy-summary">{{ policySummary }}</p>
          <p class="policy-notes" *ngIf="data.event.cancellationPolicyNotes">{{ data.event.cancellationPolicyNotes }}</p>
          <p class="policy-owner">Política definida pelo organizador do evento, que analisa os pedidos de cancelamento.</p>
        </div>
        <mat-checkbox formControlName="policyAccepted" color="primary" class="policy-check">
          Li e aceito a política de cancelamento do evento e os
          <a routerLink="/termos" target="_blank">Termos de Uso</a>.
        </mat-checkbox>
      </ng-container>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-actions">
    <button mat-button (click)="onCancel()">CANCELAR</button>
    <button mat-raised-button color="accent" (click)="onSubmit()" [disabled]="subscriptionForm.invalid"
      class="submit-btn">
      CONFIRMAR INSCRIÇÃO
    </button>
  </mat-dialog-actions>
</div>